<template>
  <div>
    <DocumentProcessing
      :notify="notify"
    />
  </div>
</template>

<script>
import DocumentProcessing from '@/febos/chile/dnt/components/wizard/companies/60100003-2/components/DocumentProcessing';

export default {
  name: 'ConventionInputForm',
  components: { DocumentProcessing },
  methods: {
    notify(message, variant, title) {
      this.$vs.notify({
        title,
        text: message,
        color: variant,
        time: 5000,
        position: 'bottom-center'
      });
    },
  },
};
</script>

<style>

</style>
